import Vue from 'vue';
import * as types from './mutation-types'
import { storage } from '@common/utils/util'

//全局mutations
export default {
    [types.UPDATE_USER_ATTR_ID](state, userAttrId) {
        state.userAttrId = userAttrId;
        storage.session.set('userAttrId', state.userAttrId);
    },

    [types.USER_INFO](state, userInfo) {
        state.userInfo = userInfo || {};
        storage.local.set('userInfo', state.userInfo);
    },

    [types.CUSTOMER_SHREF](state, link){
    	state.customerLink = link || '';
    }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js